// import React, { useState, useEffect } from "react";
// import Loader from "../utils/loader";
// import clsx from "clsx";
// import { makeStyles } from "@material-ui/core/styles";
// import TextField from "@material-ui/core/TextField";
// import { ToastContainer, toast } from "react-toastify";
// import authService from "../services/authService";
// import Group244 from "../static/Group244.png";
// import Group5702x from "../static/Group5702x.png";
// import { Link } from "react-router-dom";
// import { withRouter } from "react-router-dom";
// import "./LoginForm.css";
// import loginBackground from "../static/loginBackground.png";
// // import PetLogo from "../static/signup_login/PetLogo.png"
// import PetLogo from "../static/POET_Logo_Mid.png";
// import Login1 from "../static/login-3.png";
// import { getHomeCMS } from "../services/adminServices";
// import {
//   Card,
//   InputGroup,
//   FormControl,
//   Form,
//   Button,
//   ButtonGroup,
//   Carousel,
// } from "react-bootstrap";
// import InputBoxMui from "./ReusableComponents/InputBoxMui";
// import PoetNewlogopen from "../static/loginlogo.png";
// import CloseIcon from "@material-ui/icons/Close";
// import { useHistory } from "react-router-dom";

// const useStyles = makeStyles((theme) => ({
//   container: {
//     display: "flex",
//     flexWrap: "wrap",
//   },
//   textField: {
//     marginLeft: theme.spacing(1),
//     marginRight: theme.spacing(1),
//     width: "100%",
//   },
//   dense: {
//     marginTop: 19,
//   },
// }));
// // const headOneStyle = {
// //   fontSize: "42px",
// //   lineheight: "0.88",
// //   textAlign: "left",
// //   color: "#ffffff"
// // };
// // const headTwoStyle = {
// //   fontSize: "23px",
// //   fontWeight: "300",
// //   lineHeight: "0.91",
// //   textAlign: "left",
// //   color: "#ffffff"
// // };
// export default function ForgotPassNew() {
//   const classes = useStyles();
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [cms, setCms] = useState({});
//   let history = useHistory();

//   const getCms = async () => {
//     let cms = await getHomeCMS();
//     setCms(cms.data);
//     console.log(cms);
//   };

//   useEffect(() => {
//     getCms();
//     // return () => toast.dismiss();
//   }, []);

//   async function handleForgotPassword() {
//     setLoading(true);
//     if (!email) {
//       setLoading(false);
//       toast.warn("Please enter the email");
//       return;
//     }
//     const result = await authService.forgotpasssword({ email });
//     console.log(result);
//     if (result.status === 200) {
//       setLoading(false);
//       toast.success(result.message);
//     } else {
//       setLoading(false);
//       toast.error(result.message);
//     }
//   }

//   const handleClose = () => {
//     history.push("/login");
//   };

//   return (
//     <div
//       className="container-fluid-login"
//       style={{
//         backgroundImage: `url(${Login1})`,
//         backgroundSize: "cover",
//         backgroundRepeat: "no-repeat",
//         backgroundPosition: "center",
//         height: "100%",
//         position: "absolute",
//         top: 0,
//         left: 0,
//         // position: "relative"
//       }}
//     >
//       <ToastContainer />
//       <Loader loading={loading} />
//       <div className="d-flex col-md-12 align-items-center">
//        <div className="petLogoContainer">
//           <Link to="/">
//             <img src={PoetNewlogopen} alt="Logo" className="petLogo" />
//           </Link>
//         </div>

//         <div className="col-md-12">
//           <div className="col-sm-12 col-md-12 col-lg-12 d-flex justify-content-center">
//             <Card className="card-comp px-3 p-4">
//               <div className="text-center">
//                 {/* <h3 className="mainHeading"
//                                 style={{ color: "#353535" }}
//                             >Forgot your password?</h3>
//                             <CloseIcon onClick={handleClose} style={{ color: "red", cursor: "pointer" }} /> */}

//                 <div className="d-flex col-md-12">
//                   <h3
//                     className="mainHeading col-md-12"
//                     style={{ color: "#353535" }}
//                   >
//                     Forgot your password?
//                   </h3>
//                   <CloseIcon
//                     onClick={handleClose}
//                     style={{
//                       color: "red",
//                       cursor: "pointer",
//                       alignItems: "flex-end",
//                     }}
//                   />
//                 </div>

//                 <p
//                   style={{
//                     // opacity: "0.5",
//                     // fontSize: "12px",
//                     fontSize: "1rem",
//                     lineHeight: "1.52",
//                     // textAlign: "center",
//                     color: "#000000",
//                   }}
//                 >
//                   {/* Reset your password through email id */}
//                   Enter your registered email id to reset your password
//                 </p>
//               </div>

//               <div className="mt-4 py-2">
//                 <InputBoxMui
//                   fullWidth
//                   type="email"
//                   label="Email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   // placeholder="Username or Email"
//                 />
//               </div>

//               <div className="text-center mt-4 py-2">
//                 <Button
//                   className="resetPassword"
//                   onClick={handleForgotPassword}
//                 >
//                   Reset Password
//                 </Button>
//               </div>
//             </Card>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useState, useEffect, useRef } from "react";
// import Loader from "../utils/loader";
// import { ToastContainer, toast } from "react-toastify";
// import authService from "../services/authService";
// import { Link } from "react-router-dom";
// import { useHistory } from "react-router-dom";
// import "./LoginForm.css";

// // MUI imports
// import {
//   Box,
//   Card,
//   Typography,
//   Button,
//   Paper
// } from "@mui/material";
// import Grid2 from "@mui/material/Unstable_Grid2";
// import TextField from "@mui/material/TextField";
// import CloseIcon from "@mui/icons-material/Close";
// import { styled, keyframes } from "@mui/material/styles";
// import PoetNewlogopen from "../static/loginlogo.png";

// // 3D and Advanced Animations
// const float3D = keyframes`
//   0% {
//     transform: translateZ(0px) translateY(0px) rotateX(0deg) rotateY(0deg);
//     filter: drop-shadow(0 10px 15px rgba(0, 100, 255, 0.3));
//   }
//   25% {
//     transform: translateZ(100px) translateY(-30px) rotateX(10deg) rotateY(5deg);
//     filter: drop-shadow(20px 30px 25px rgba(0, 150, 255, 0.5));
//   }
//   50% {
//     transform: translateZ(50px) translateY(0px) rotateX(5deg) rotateY(-5deg);
//     filter: drop-shadow(-20px 20px 25px rgba(0, 200, 255, 0.4));
//   }
//   75% {
//     transform: translateZ(80px) translateY(20px) rotateX(-5deg) rotateY(10deg);
//     filter: drop-shadow(15px -20px 25px rgba(0, 175, 255, 0.5));
//   }
//   100% {
//     transform: translateZ(0px) translateY(0px) rotateX(0deg) rotateY(0deg);
//     filter: drop-shadow(0 10px 15px rgba(0, 100, 255, 0.3));
//   }
// `;

// const rotate3D = keyframes`
//   0% {
//     transform: perspective(1000px) rotateY(0deg) rotateX(20deg) translateZ(0px);
//   }
//   25% {
//     transform: perspective(1000px) rotateY(90deg) rotateX(25deg) translateZ(50px);
//   }
//   50% {
//     transform: perspective(1000px) rotateY(180deg) rotateX(20deg) translateZ(100px);
//   }
//   75% {
//     transform: perspective(1000px) rotateY(270deg) rotateX(15deg) translateZ(50px);
//   }
//   100% {
//     transform: perspective(1000px) rotateY(360deg) rotateX(20deg) translateZ(0px);
//   }
// `;

// const wave3D = keyframes`
//   0% {
//     transform: perspective(800px) rotateX(0deg) rotateY(0deg) translateZ(0px) scale(1);
//   }
//   33% {
//     transform: perspective(800px) rotateX(20deg) rotateY(10deg) translateZ(80px) scale(1.1);
//   }
//   66% {
//     transform: perspective(800px) rotateX(-10deg) rotateY(-15deg) translateZ(60px) scale(0.95);
//   }
//   100% {
//     transform: perspective(800px) rotateX(0deg) rotateY(0deg) translateZ(0px) scale(1);
//   }
// `;

// const bounce3D = keyframes`
//   0%, 100% {
//     transform: translateY(0) translateZ(0) scale(1);
//     filter: brightness(1);
//   }
//   25% {
//     transform: translateY(-60px) translateZ(80px) scale(1.1);
//     filter: brightness(1.3);
//   }
//   50% {
//     transform: translateY(20px) translateZ(40px) scale(0.95);
//     filter: brightness(0.9);
//   }
//   75% {
//     transform: translateY(-30px) translateZ(60px) scale(1.05);
//     filter: brightness(1.1);
//   }
// `;

// const spin3D = keyframes`
//   0% {
//     transform: rotate3d(1, 1, 1, 0deg) translateZ(0px);
//   }
//   25% {
//     transform: rotate3d(1, 1, 1, 120deg) translateZ(50px);
//   }
//   50% {
//     transform: rotate3d(1, 1, 1, 240deg) translateZ(100px);
//   }
//   100% {
//     transform: rotate3d(1, 1, 1, 360deg) translateZ(0px);
//   }
// `;

// const particleFloat = keyframes`
//   0% {
//     transform: translateY(0) translateX(0) translateZ(0) rotate(0deg);
//     opacity: 0;
//   }
//   25% {
//     transform: translateY(-50px) translateX(30px) translateZ(50px) rotate(90deg);
//     opacity: 0.8;
//   }
//   50% {
//     transform: translateY(-100px) translateX(-30px) translateZ(100px) rotate(180deg);
//     opacity: 1;
//   }
//   75% {
//     transform: translateY(-150px) translateX(20px) translateZ(50px) rotate(270deg);
//     opacity: 0.5;
//   }
//   100% {
//     transform: translateY(-200px) translateX(0) translateZ(0px) rotate(360deg);
//     opacity: 0;
//   }
// `;

// const glowPulse3D = keyframes`
//   0% {
//     box-shadow: 0 0 20px rgba(0, 150, 255, 0.3),
//                 0 0 40px rgba(0, 150, 255, 0.2),
//                 0 0 60px rgba(0, 150, 255, 0.1),
//                 inset 0 0 30px rgba(255, 255, 255, 0.2);
//     transform: scale(1);
//   }
//   50% {
//     box-shadow: 0 0 40px rgba(0, 200, 255, 0.6),
//                 0 0 80px rgba(0, 200, 255, 0.4),
//                 0 0 120px rgba(0, 200, 255, 0.2),
//                 inset 0 0 50px rgba(255, 255, 255, 0.4);
//     transform: scale(1.02) translateZ(20px);
//   }
//   100% {
//     box-shadow: 0 0 20px rgba(0, 150, 255, 0.3),
//                 0 0 40px rgba(0, 150, 255, 0.2),
//                 0 0 60px rgba(0, 150, 255, 0.1),
//                 inset 0 0 30px rgba(255, 255, 255, 0.2);
//     transform: scale(1);
//   }
// `;

// const backgroundWave = keyframes`
//   0% {
//     background-position: 0% 0%;
//   }
//   25% {
//     background-position: 100% 0%;
//   }
//   50% {
//     background-position: 100% 100%;
//   }
//   75% {
//     background-position: 0% 100%;
//   }
//   100% {
//     background-position: 0% 0%;
//   }
// `;

// // Styled Components with 3D effects
// const AnimatedBackground = styled(Box)({
//   position: "fixed",
//   top: 0,
//   left: 0,
//   right: 0,
//   bottom: 0,
//   overflow: "hidden",
//   background: "linear-gradient(145deg, #ffffff 0%, #e6f3ff 25%, #b3d9ff 50%, #80bfff 75%, #4da6ff 100%)",
//   backgroundSize: "400% 400%",
//   animation: `${backgroundWave} 20s ease infinite`,
//   perspective: "1000px",
//   transformStyle: "preserve-3d",
//   zIndex: -1,
// });

// const FloatingCube = styled(Box)(({ top, left, delay, size }) => ({
//   position: "absolute",
//   width: size,
//   height: size,
//   top: top,
//   left: left,
//   transformStyle: "preserve-3d",
//   animation: `${float3D} ${10 + delay}s ease-in-out infinite`,
//   transformOrigin: "center center",
//   "&::before": {
//     content: '""',
//     position: "absolute",
//     width: "100%",
//     height: "100%",
//     background: "linear-gradient(145deg, rgba(255,255,255,0.2), rgba(77, 166, 255, 0.1))",
//     border: "1px solid rgba(77, 166, 255, 0.3)",
//     transform: "rotateY(90deg) translateX(50%)",
//     transformOrigin: "left",
//   },
//   "&::after": {
//     content: '""',
//     position: "absolute",
//     width: "100%",
//     height: "100%",
//     background: "linear-gradient(145deg, rgba(255,255,255,0.2), rgba(77, 166, 255, 0.1))",
//     border: "1px solid rgba(77, 166, 255, 0.3)",
//     transform: "rotateX(90deg) translateY(50%)",
//     transformOrigin: "bottom",
//   },
// }));

// const CubeFace = styled(Box)(({ transform }) => ({
//   position: "absolute",
//   width: "100%",
//   height: "100%",
//   background: "linear-gradient(145deg, rgba(255,255,255,0.3), rgba(77, 166, 255, 0.2))",
//   border: "1px solid rgba(77, 166, 255, 0.4)",
//   boxShadow: "0 0 30px rgba(77, 166, 255, 0.3)",
//   backdropFilter: "blur(5px)",
//   transform: transform,
// }));

// const FloatingSphere = styled(Box)(({ top, left, delay, size }) => ({
//   position: "absolute",
//   width: size,
//   height: size,
//   top: top,
//   left: left,
//   borderRadius: "50%",
//   background: "radial-gradient(circle at 30% 30%, #fff, #4da6ff)",
//   animation: `${bounce3D} ${8 + delay}s ease-in-out infinite`,
//   boxShadow: "0 0 50px rgba(77, 166, 255, 0.6)",
//   transformStyle: "preserve-3d",
//   "&::before": {
//     content: '""',
//     position: "absolute",
//     width: "100%",
//     height: "100%",
//     borderRadius: "50%",
//     background: "radial-gradient(circle at 70% 70%, rgba(255,255,255,0.8), transparent)",
//     transform: "translateZ(10px)",
//   },
// }));

// const FloatingRing = styled(Box)(({ top, left, delay }) => ({
//   position: "absolute",
//   width: "150px",
//   height: "150px",
//   top: top,
//   left: left,
//   border: "3px solid rgba(77, 166, 255, 0.4)",
//   borderRadius: "50%",
//   animation: `${rotate3D} ${12 + delay}s linear infinite`,
//   transformStyle: "preserve-3d",
//   boxShadow: "0 0 40px rgba(77, 166, 255, 0.3)",
//   "&::before": {
//     content: '""',
//     position: "absolute",
//     width: "100%",
//     height: "100%",
//     border: "3px solid rgba(255, 255, 255, 0.3)",
//     borderRadius: "50%",
//     transform: "rotateX(90deg)",
//   },
//   "&::after": {
//     content: '""',
//     position: "absolute",
//     width: "100%",
//     height: "100%",
//     border: "3px solid rgba(255, 255, 255, 0.3)",
//     borderRadius: "50%",
//     transform: "rotateY(90deg)",
//   },
// }));

// const FloatingPyramid = styled(Box)(({ top, left, delay }) => ({
//   position: "absolute",
//   width: "0",
//   height: "0",
//   top: top,
//   left: left,
//   borderLeft: "50px solid transparent",
//   borderRight: "50px solid transparent",
//   borderBottom: "100px solid rgba(77, 166, 255, 0.3)",
//   filter: "drop-shadow(0 0 30px rgba(77, 166, 255, 0.5))",
//   animation: `${wave3D} ${10 + delay}s ease-in-out infinite`,
//   transformStyle: "preserve-3d",
//   "&::before": {
//     content: '""',
//     position: "absolute",
//     top: "35px",
//     left: "-35px",
//     width: "0",
//     height: "0",
//     borderLeft: "35px solid transparent",
//     borderRight: "35px solid transparent",
//     borderBottom: "70px solid rgba(255, 255, 255, 0.2)",
//     transform: "rotateX(180deg) translateZ(10px)",
//   },
// }));

// const Particle = styled(Box)(({ top, left, delay, color }) => ({
//   position: "absolute",
//   width: "6px",
//   height: "6px",
//   top: top,
//   left: left,
//   background: color || "#4da6ff",
//   borderRadius: "50%",
//   boxShadow: `0 0 20px ${color || "#4da6ff"}`,
//   animation: `${particleFloat} ${8 + delay}s linear infinite`,
//   transformStyle: "preserve-3d",
// }));

// const StyledCard = styled(Card)({
//   background: "rgba(255, 255, 255, 0.15)",
//   backdropFilter: "blur(20px)",
//   borderRadius: "30px",
//   border: "1px solid rgba(77, 166, 255, 0.3)",
//   boxShadow: "0 20px 50px rgba(0, 100, 255, 0.3), inset 0 0 30px rgba(255, 255, 255, 0.5)",
//   padding: "40px",
//   width: "100%",
//   maxWidth: "450px",
//   animation: `${float3D} 10s ease-in-out infinite, ${glowPulse3D} 4s ease-in-out infinite`,
//   transformStyle: "preserve-3d",
//   position: "relative",
//   zIndex: 10,
//   "&:hover": {
//     animation: `${float3D} 5s ease-in-out infinite, ${glowPulse3D} 2s ease-in-out infinite`,
//   },
// });

// const StyledTextField = styled(TextField)({
//   "& .MuiInputLabel-root": {
//     color: "#0066cc",
//     fontWeight: "500",
//     textShadow: "0 2px 4px rgba(255,255,255,0.3)",
//   },
//   "& .MuiInputLabel-root.Mui-focused": {
//     color: "#004080",
//     transform: "translateZ(20px)",
//   },
//   "& .MuiInputBase-root": {
//     color: "#003366",
//     "&:before": {
//       borderBottomColor: "#4da6ff",
//     },
//     "&:hover:not(.Mui-disabled):before": {
//       borderBottomColor: "#0066cc",
//       borderBottomWidth: "2px",
//     },
//     "&:after": {
//       borderBottomColor: "#004080",
//     },
//   },
//   "& .MuiFormHelperText-root": {
//     color: "#0066cc",
//   },
// });

// const StyledButton = styled(Button)({
//   background: "linear-gradient(145deg, #ffffff 0%, #4da6ff 50%, #0066cc 100%)",
//   border: "none",
//   borderRadius: "30px",
//   boxShadow: "0 10px 30px rgba(0, 102, 204, 0.4), 0 0 20px rgba(255, 255, 255, 0.3)",
//   color: "white",
//   height: 50,
//   padding: "0 40px",
//   fontSize: "1.1rem",
//   fontWeight: "bold",
//   letterSpacing: "1px",
//   textTransform: "uppercase",
//   transition: "all 0.3s ease",
//   transformStyle: "preserve-3d",
//   position: "relative",
//   "&:hover": {
//     transform: "translateY(-5px) translateZ(30px) scale(1.05)",
//     boxShadow: "0 15px 40px rgba(0, 102, 204, 0.6), 0 0 30px rgba(255, 255, 255, 0.5)",
//     background: "linear-gradient(145deg, #ffffff 0%, #0066cc 50%, #004080 100%)",
//   },
//   "&::before": {
//     content: '""',
//     position: "absolute",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     borderRadius: "30px",
//     background: "linear-gradient(145deg, rgba(255,255,255,0.5), transparent)",
//     transform: "translateZ(-10px)",
//     opacity: 0,
//     transition: "opacity 0.3s ease",
//   },
//   "&:hover::before": {
//     opacity: 1,
//   },
// });

// const LogoContainer = styled(Box)({
//   position: "absolute",
//   top: "30px",
//   left: "30px",
//   zIndex: 20,
//   animation: `${float3D} 8s ease-in-out infinite`,
//   transformStyle: "preserve-3d",
//   "& img": {
//     width: "180px",
//     height: "auto",
//     filter: "drop-shadow(0 10px 20px rgba(0, 102, 204, 0.4))",
//     transition: "all 0.3s ease",
//   },
//   "&:hover": {
//     animation: `${spin3D} 3s ease-in-out infinite`,
//   },
// });

// const CloseButton = styled(CloseIcon)({
//   color: "#0066cc",
//   cursor: "pointer",
//   position: "absolute",
//   top: "30px",
//   right: "30px",
//   zIndex: 20,
//   fontSize: "40px",
//   backgroundColor: "rgba(255, 255, 255, 0.3)",
//   borderRadius: "50%",
//   padding: "8px",
//   transition: "all 0.3s ease",
//   backdropFilter: "blur(10px)",
//   boxShadow: "0 5px 15px rgba(0, 102, 204, 0.3)",
//   animation: `${float3D} 6s ease-in-out infinite`,
//   "&:hover": {
//     transform: "rotate(180deg) translateZ(50px) scale(1.2)",
//     backgroundColor: "rgba(255, 68, 68, 0.3)",
//     color: "#ff4444",
//     boxShadow: "0 10px 25px rgba(255, 68, 68, 0.4)",
//   },
// });

// const AnimatedText = styled(Typography)({
//   animation: `${float3D} 8s ease-in-out infinite`,
//   transformStyle: "preserve-3d",
//   textShadow: "0 5px 15px rgba(0, 102, 204, 0.3)",
// });

// const ParticleSystem = styled(Box)({
//   position: "absolute",
//   top: 0,
//   left: 0,
//   right: 0,
//   bottom: 0,
//   pointerEvents: "none",
//   transformStyle: "preserve-3d",
//   perspective: "1000px",
// });

// export default function ForgotPassNew() {
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
//   const cardRef = useRef(null);
//   let history = useHistory();

//   useEffect(() => {
//     const handleMouseMove = (e) => {
//       setMousePosition({
//         x: (e.clientX / window.innerWidth - 0.5) * 20,
//         y: (e.clientY / window.innerHeight - 0.5) * 20,
//       });
//     };
//     window.addEventListener("mousemove", handleMouseMove);
//     return () => window.removeEventListener("mousemove", handleMouseMove);
//   }, []);

//   async function handleForgotPassword() {
//     setLoading(true);
//     if (!email) {
//       setLoading(false);
//       toast.warn("Please enter the email", {
//         style: {
//           background: "rgba(255, 255, 255, 0.9)",
//           color: "#0066cc",
//           backdropFilter: "blur(10px)",
//         },
//       });
//       return;
//     }
//     const result = await authService.forgotpasssword({ email });
//     if (result.status === 200) {
//       setLoading(false);
//       toast.success(result.message);
//     } else {
//       setLoading(false);
//       toast.error(result.message);
//     }
//   }

//   const handleClose = () => {
//     history.push("/login");
//   };

//   return (
//     <Box sx={{ position: "relative", minHeight: "100vh", overflow: "hidden" }}>
//       <ToastContainer
//         position="top-right"
//         autoClose={5000}
//         hideProgressBar={false}
//         newestOnTop
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="light"
//       />
//       <Loader loading={loading} />

//       {/* 3D Animated Background */}
//       <AnimatedBackground />

//       {/* 3D Elements */}
//       <Box sx={{ position: "absolute", width: "100%", height: "100%", perspective: "1000px" }}>
//         {/* Floating Cubes */}
//         {[...Array(6)].map((_, i) => (
//           <FloatingCube
//             key={`cube-${i}`}
//             top={`${Math.random() * 80}%`}
//             left={`${Math.random() * 80}%`}
//             delay={i * 2}
//             size={`${80 + Math.random() * 70}px`}
//           >
//             <CubeFace transform="translateZ(40px)" />
//             <CubeFace transform="rotateY(180deg) translateZ(40px)" />
//             <CubeFace transform="rotateY(90deg) translateZ(40px)" />
//             <CubeFace transform="rotateY(-90deg) translateZ(40px)" />
//             <CubeFace transform="rotateX(90deg) translateZ(40px)" />
//             <CubeFace transform="rotateX(-90deg) translateZ(40px)" />
//           </FloatingCube>
//         ))}

//         {/* Floating Spheres */}
//         {[...Array(8)].map((_, i) => (
//           <FloatingSphere
//             key={`sphere-${i}`}
//             top={`${Math.random() * 90}%`}
//             left={`${Math.random() * 90}%`}
//             delay={i * 1.5}
//             size={`${40 + Math.random() * 60}px`}
//           />
//         ))}

//         {/* Floating Rings */}
//         {[...Array(4)].map((_, i) => (
//           <FloatingRing
//             key={`ring-${i}`}
//             top={`${Math.random() * 70}%`}
//             left={`${Math.random() * 70}%`}
//             delay={i * 3}
//           />
//         ))}

//         {/* Floating Pyramids */}
//         {[...Array(5)].map((_, i) => (
//           <FloatingPyramid
//             key={`pyramid-${i}`}
//             top={`${Math.random() * 85}%`}
//             left={`${Math.random() * 85}%`}
//             delay={i * 2.5}
//           />
//         ))}

//         {/* Particle System */}
//         <ParticleSystem>
//           {[...Array(50)].map((_, i) => (
//             <Particle
//               key={`particle-${i}`}
//               top={`${Math.random() * 100}%`}
//               left={`${Math.random() * 100}%`}
//               delay={Math.random() * 5}
//               color={`rgba(${77 + Math.random() * 100}, ${166 + Math.random() * 89}, 255, 0.8)`}
//             />
//           ))}
//         </ParticleSystem>
//       </Box>

//       {/* Logo */}
//       <LogoContainer>
//         <Link to="/">
//           <img src={PoetNewlogopen} alt="Logo" />
//         </Link>
//       </LogoContainer>

//       {/* Close Button */}
//       <CloseButton onClick={handleClose} />

//       {/* Main Content with 3D Tilt Effect */}
//       <Grid2
//         container
//         sx={{
//           minHeight: "100vh",
//           alignItems: "center",
//           justifyContent: "center",
//           position: "relative",
//           zIndex: 10,
//           px: 2,
//           transformStyle: "preserve-3d",
//           perspective: "1000px",
//         }}
//       >
//         <Grid2 xs={12} md={8} lg={6} xl={4}>
//           <StyledCard
//             ref={cardRef}
//             sx={{
//               transform: `rotateX(${mousePosition.y}deg) rotateY(${mousePosition.x}deg)`,
//               transition: "transform 0.1s ease",
//             }}
//           >
//             <Box sx={{ textAlign: "center", mb: 4 }}>
//               <AnimatedText
//                 variant="h4"
//                 sx={{
//                   color: "#003366",
//                   fontWeight: "bold",
//                   mb: 2,
//                   textShadow: "0 5px 15px rgba(0, 102, 204, 0.3)",
//                   fontSize: "2.2rem",
//                 }}
//               >
//                 Forgot Password?
//               </AnimatedText>
//               <Typography
//                 variant="body1"
//                 sx={{
//                   color: "#004080",
//                   fontSize: "1.1rem",
//                   lineHeight: 1.6,
//                   fontWeight: "500",
//                   textShadow: "0 2px 5px rgba(255,255,255,0.5)",
//                 }}
//               >
//                 Enter your registered email to reset your password
//               </Typography>
//             </Box>

//             <Box sx={{ mb: 4 }}>
//               <StyledTextField
//                 fullWidth
//                 type="email"
//                 label="Email Address"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 variant="standard"
//               />
//             </Box>

//             <Box sx={{ textAlign: "center" }}>
//               <StyledButton
//                 onClick={handleForgotPassword}
//                 disabled={loading}
//                 fullWidth
//               >
//                 {loading ? "Processing..." : "Reset Password"}
//               </StyledButton>
//             </Box>

//             {/* 3D Decorative Elements */}
//             <Box
//               sx={{
//                 position: "absolute",
//                 bottom: 20,
//                 right: 20,
//                 display: "flex",
//                 gap: 1.5,
//               }}
//             >
//               {[1, 2, 3].map((num) => (
//                 <Box
//                   key={num}
//                   sx={{
//                     width: 12,
//                     height: 12,
//                     borderRadius: "50%",
//                     background: "linear-gradient(145deg, #4da6ff, #0066cc)",
//                     animation: `${bounce3D} ${1 + num * 0.3}s ease-in-out infinite`,
//                     transformStyle: "preserve-3d",
//                     boxShadow: "0 0 20px #4da6ff",
//                   }}
//                 />
//               ))}
//             </Box>
//           </StyledCard>
//         </Grid2>
//       </Grid2>

//       {/* Floating Particles in Foreground */}
//       <ParticleSystem>
//         {[...Array(30)].map((_, i) => (
//           <Particle
//             key={`fg-particle-${i}`}
//             top={`${Math.random() * 100}%`}
//             left={`${Math.random() * 100}%`}
//             delay={Math.random() * 8}
//             color={`rgba(0, ${102 + Math.random() * 153}, 255, 0.6)`}
//           />
//         ))}
//       </ParticleSystem>
//     </Box>
//   );
// }

import React, { useState, useEffect } from "react";
import Loader from "../utils/loader";
import { ToastContainer, toast } from "react-toastify";
import authService from "../services/authService";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import "./LoginForm.css";
import Login1 from "../static/login-3.png";
import { getHomeCMS } from "../services/adminServices";
import { Card, Button } from "react-bootstrap";
import InputBoxMui from "./ReusableComponents/InputBoxMui";
import PoetNewlogopen from "../static/loginlogo.png";
import CloseIcon from "@material-ui/icons/Close";
import { useHistory } from "react-router-dom";

// MUI Grid v2 import
import Grid from "@mui/material/Unstable_Grid2";

// Animation keyframes and styles (matching signup page)
const customStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

  * {
    font-family: 'Poppins', sans-serif;
  }

  /* Floating Animation */
  @keyframes float {
    0% {
      transform: translateY(0px) rotate(0deg);
    }
    50% {
      transform: translateY(-15px) rotate(2deg);
    }
    100% {
      transform: translateY(0px) rotate(0deg);
    }
  }

  /* Jumping Animation */
  @keyframes jump {
    0%, 100% {
      transform: translateY(0) scale(1);
    }
    50% {
      transform: translateY(-20px) scale(1.05);
    }
  }

  /* Rotation Animation */
  @keyframes rotate {
    from {
      transform: rotate(0deg) scale(1);
    }
    to {
      transform: rotate(360deg) scale(1.05);
    }
  }

  /* Pulse Animation */
  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 0.8;
    }
    50% {
      transform: scale(1.05);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 0.8;
    }
  }

  /* Slide In Animation */
  @keyframes slideIn {
    from {
      transform: translateX(-50px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  /* Wave Animation */
  @keyframes wave {
    0% {
      transform: translateX(0) translateY(0);
    }
    25% {
      transform: translateX(10px) translateY(-10px);
    }
    50% {
      transform: translateX(0) translateY(0);
    }
    75% {
      transform: translateX(-10px) translateY(10px);
    }
    100% {
      transform: translateX(0) translateY(0);
    }
  }

  /* Background moving gradient - White/Blue theme */
  @keyframes gradientMove {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  /* Shimmer Effect */
  @keyframes shimmer {
    0% {
      background-position: -100% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }

  .animated-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      135deg,
      #d9e3f4,
      #dbe5f8,
      #d0d7df,
      #d9e9ff,
      #e2e9ef
    );
    background-size: 400% 400%;
    animation: gradientMove 15s ease infinite;
    z-index: -2;
  }

  .floating-shapes {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: -1;
    overflow: hidden;
  }

  .shape {
    position: absolute;
    background: rgba(33, 150, 243, 0.08);
    border-radius: 50%;
    filter: blur(8px);
  }

  .shape-1 {
    width: 400px;
    height: 400px;
    top: -150px;
    right: -100px;
    animation: float 10s ease-in-out infinite;
    background: radial-gradient(circle, rgba(33,150,243,0.15) 0%, transparent 70%);
  }

  .shape-2 {
    width: 350px;
    height: 350px;
    bottom: -100px;
    left: -100px;
    animation: float 12s ease-in-out infinite reverse;
    background: radial-gradient(circle, rgba(25,118,210,0.12) 0%, transparent 70%);
  }

  .shape-3 {
    width: 200px;
    height: 200px;
    top: 20%;
    left: 15%;
    animation: jump 7s ease-in-out infinite;
    background: radial-gradient(circle, rgba(100,181,246,0.1) 0%, transparent 70%);
    border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;
  }

  .shape-4 {
    width: 250px;
    height: 250px;
    bottom: 25%;
    right: 10%;
    animation: rotate 20s linear infinite;
    border: 2px solid rgba(33, 150, 243, 0.1);
    background: transparent;
    border-radius: 40% 60% 60% 40% / 40% 40% 60% 60%;
  }

  .shape-5 {
    width: 150px;
    height: 150px;
    top: 60%;
    left: 20%;
    animation: wave 8s ease-in-out infinite;
    background: rgba(33, 150, 243, 0.07);
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  }

  .shape-6 {
    width: 180px;
    height: 180px;
    top: 15%;
    right: 25%;
    animation: float 9s ease-in-out infinite;
    background: rgba(25, 118, 210, 0.06);
    border-radius: 20% 80% 80% 20% / 20% 20% 80% 80%;
  }

  /* Bubbles */
  .bubble {
    position: absolute;
    background: rgba(33, 150, 243, 0.1);
    border-radius: 50%;
    animation: float 6s ease-in-out infinite;
  }

  .bubble-1 {
    width: 60px;
    height: 60px;
    top: 10%;
    left: 10%;
    animation-delay: 0s;
  }

  .bubble-2 {
    width: 40px;
    height: 40px;
    top: 30%;
    right: 15%;
    animation-delay: 1s;
  }

  .bubble-3 {
    width: 80px;
    height: 80px;
    bottom: 20%;
    left: 15%;
    animation-delay: 2s;
  }

  .bubble-4 {
    width: 50px;
    height: 50px;
    bottom: 40%;
    right: 20%;
    animation-delay: 1.5s;
  }

  /* Card Styles - White/Blue theme with 3D effect */
  .forgot-card {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(33, 150, 243, 0.2) !important;
    border-radius: 30px !important;
    box-shadow: 
      0 30px 60px rgba(33, 150, 243, 0.15),
      0 10px 30px rgba(0, 0, 0, 0.1),
      inset 0 -5px 15px rgba(33, 150, 243, 0.1) !important;
    animation: slideIn 0.8s ease-out;
    max-width: 500px !important;
    width: 100% !important;
    margin: 10px !important;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
    transform-style: preserve-3d;
    perspective: 1000px;
    padding: 2rem !important;
  }

  // .forgot-card:hover {
  //   transform: translateY(-10px) rotateX(5deg) rotateY(2deg) scale(1.02);
  //   box-shadow: 
  //     0 30px 60px rgba(33, 150, 243, 0.25),
  //     0 10px 30px rgba(0, 0, 0, 0.15),
  //     inset 0 -5px 15px rgba(33, 150, 243, 0.15) !important;
  // }
.forgot-card:hover {
  transform: translateY(-3px) scale(1.01);
  box-shadow: 
    0 40px 70px rgba(33, 150, 243, 0.18),
    0 15px 35px rgba(0, 0, 0, 0.12) !important;
}
  .mainHeading {
    color: #1a237e !important;
    font-size: 2.2rem !important;
    font-weight: 600 !important;
    text-shadow: 2px 2px 4px rgba(33, 150, 243, 0.2);
    letter-spacing: 1px;
    margin-bottom: 15px !important;
    position: relative;
    display: inline-block;
    animation: pulse 3s ease-in-out infinite;
  }

  .mainHeading::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #2196f3, #64b5f6, #2196f3);
    border-radius: 3px;
    animation: shimmer 2s infinite;
    background-size: 200% 100%;
  }

  /* Input field styles for white-blue theme */
  .MuiInputBase-root {
    color: #1a237e !important;
    background: rgba(255, 255, 255, 0.9) !important;
    border-radius: 12px !important;
    transition: all 0.3s ease !important;
  }

  .MuiInputLabel-root {
    color: #000000 !important;
    font-weight: 700 !important;
    font-size: 0.95rem !important; 
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: rgb(27, 152, 255) !important;
    border-width: 0.5px !important;
    border-radius: 12px !important;
  }

  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #2196f3 !important;
    box-shadow: 0 0 15px rgba(33, 150, 243, 0.3) !important;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #1976d2 !important;
    border-width: 1px !important;
    box-shadow: 0 0 20px rgba(33, 150, 243, 0.4) !important;
  }

  .MuiInputBase-input {
  color: #000000 !important; 
}
  .MuiInputBase-input::placeholder {
  color: #000000 !important;
  opacity: 0.7;
}

  /* Button styles with 3D effect */
  .resetPassword {
    background: linear-gradient(145deg, #2196f3, #1976d2) !important;
    border: none !important;
    border-radius: 12px !important;
    color: white !important;
    font-weight: 600 !important;
    padding: 12px 40px !important;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
    text-transform: uppercase !important;
    letter-spacing: 1px !important;
    position: relative !important;
    overflow: hidden !important;
    box-shadow: 
      0 10px 20px rgba(33, 150, 243, 0.3),
      0 3px 6px rgba(0, 0, 0, 0.1),
      inset 0 -2px 5px rgba(255, 255, 255, 0.3) !important;
    transform-style: preserve-3d;
    width: 100%;
    font-size: 1.1rem !important;
    cursor: pointer;
  }

  .resetPassword:hover:not(:disabled) {
    transform: translateY(-5px) scale(1.05) rotateX(5deg);
    box-shadow: 
      0 20px 30px rgba(33, 150, 243, 0.4),
      0 5px 15px rgba(0, 0, 0, 0.2),
      inset 0 -2px 8px rgba(255, 255, 255, 0.4) !important;
  }

  .resetPassword:active:not(:disabled) {
    transform: translateY(2px) scale(0.98);
    box-shadow: 0 5px 10px rgba(33, 150, 243, 0.2) !important;
  }

  .resetPassword::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
    transition: left 0.5s ease;
  }

  .resetPassword:hover::before {
    left: 100%;
  }

  .resetPassword:disabled {
    opacity: 0.6;
    transform: none !important;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1) !important;
    background: linear-gradient(145deg, #b0bec5, #90a4ae) !important;
    cursor: not-allowed;
  }

  /* Close Icon */
  .close-icon {
  position: absolute;
  right: 0;
    color: #f44336 !important;
    cursor: pointer !important;
    transition: all 0.3s ease !important;
    font-size: 2rem !important;
    animation: pulse 2s ease-in-out infinite;
  }

  .close-icon:hover {
    transform: scale(1.2) rotate(90deg);
    color: #d32f2f !important;
  }

  /* Description text */
  .description-text {
    color: #000000  !important;
    font-size: 1rem !important;
    line-height: 1.6 !important;
    margin-top: 10px !important;
    animation: slideIn 0.8s ease-out;
  }

  /* Logo */
  .petLogoContainer {
    position: fixed !important;
    top: 25px !important;
    left: 25px !important;
    z-index: 1000 !important;
  }

  .petLogo {
    max-width: 150px !important;
    filter: drop-shadow(0 10px 15px rgba(33, 150, 243, 0.3)) !important;
    animation: float 6s ease-in-out infinite !important;
    transition: all 0.3s ease !important;
  }

  .petLogo:hover {
    transform: scale(1.1) rotate(5deg);
    filter: drop-shadow(0 15px 20px rgba(33, 150, 243, 0.4)) !important;
  }

  /* Header container */
  .header-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-bottom: 10px;
    position: relative;
  }

  /* Grid Container */
  .grid-container {
    min-height: 100vh;
    width: 100%;
    padding: 20px;
  }

  /* Responsive adjustments */
  @media (max-width: 600px) {
    .forgot-card {
      margin: 10px !important;
      padding: 1.5rem !important;
    }
    
    .mainHeading {
      font-size: 1.8rem !important;
    }
    
    .petLogo {
      max-width: 100px !important;
    }
  }
`;

export default function ForgotPassNew() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [cms, setCms] = useState({});
  let history = useHistory();

  const getCms = async () => {
    let cms = await getHomeCMS();
    setCms(cms.data);
    console.log(cms);
  };

  useEffect(() => {
    getCms();
  }, []);

  async function handleForgotPassword() {
    setLoading(true);
    if (!email) {
      setLoading(false);
      toast.warn("Please enter the email");
      return;
    }

    // Email validation using a regular expression
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email)) {
      setLoading(false);
      toast.warn("Please enter a valid email address.");
      return;
    }

    const result = await authService.forgotpasssword({ email });
    console.log(result);
    if (result.status === 200) {
      setLoading(false);
      toast.success(result.message);
      setEmail("");
    } else {
      setLoading(false);
      toast.error(result.message);
    }
  }

  const handleClose = () => {
    history.push("/login");
  };

  return (
    <>
      {/* Inject custom styles */}
      <style>{customStyles}</style>

      {/* Animated Background */}
      <div className="animated-background"></div>

      {/* Floating Shapes */}
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
        <div className="shape shape-5"></div>
        <div className="shape shape-6"></div>

        {/* Bubbles */}
        <div className="bubble bubble-1"></div>
        <div className="bubble bubble-2"></div>
        <div className="bubble bubble-3"></div>
        <div className="bubble bubble-4"></div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Loader loading={loading} />

      {/* Logo */}
      <div className="petLogoContainer">
        <Link to="/">
          <img src={PoetNewlogopen} alt="Logo" className="petLogo" />
        </Link>
      </div>

      {/* MUI Grid v2 Container */}
      <Grid
        container
        spacing={0}
        className="grid-container"
        alignItems="center"
        justifyContent="center"
        sx={{
          minHeight: "100vh",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Grid
          xs={12}
          sm={10}
          md={8}
          lg={6}
          xl={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card className="forgot-card">
            <div className="header-container">
              <h3 className="mainHeading">Forgot Password?</h3>
              <CloseIcon onClick={handleClose} className="close-icon" />
            </div>

            <p className="description-text text-center">
              Enter your registered email id to reset your password
            </p>

            <div className="mt-4">
              <InputBoxMui
                fullWidth
                type="email"
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
              />
            </div>

            <div className="text-center mt-5">
              <Button
                className="resetPassword"
                onClick={handleForgotPassword}
                disabled={loading || !email}
              >
                {loading ? "Sending..." : "Reset Password"}
              </Button>
            </div>

            <div className="text-center mt-4">
              <p className="mb-0" style={{ color: "#000000" }}>
                Remember your password?{" "}
                <Link
                  to="/login"
                  className="signinLink"
                  style={{
                    color: "#1976d2",
                    textDecoration: "none",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = "#0d47a1";
                    e.target.style.textShadow =
                      "0 0 10px rgba(33, 150, 243, 0.3)";
                    e.target.style.transform = "translateX(5px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = "#1976d2";
                    e.target.style.textShadow = "none";
                    e.target.style.transform = "translateX(0)";
                  }}
                >
                  Login
                </Link>
              </p>
            </div>

            <div className="text-center mt-3">
              <Link
                to="/privacypolicy"
                target="_blank"
                className="privacyLink"
                style={{
                  color: "#546e7a",
                  textDecoration: "none",
                  fontSize: "0.9rem",
                  fontWeight: "500",
                  transition: "all 0.3s ease",
                  position: "relative",
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#1976d2";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "#546e7a";
                }}
              >
                Term of use. Privacy policy
              </Link>
            </div>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
